import { render, staticRenderFns } from "./HistorialReenvioEncuestas.vue?vue&type=template&id=6a5fec29&"
import script from "./HistorialReenvioEncuestas.vue?vue&type=script&lang=js&"
export * from "./HistorialReenvioEncuestas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports